import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";

const InspectorGroupHeading = props => {
  return <div className="inspectorGroupHeading">{props.children}</div>;
};

InspectorGroupHeading.propTypes = {
  children: PropTypes.oneOfType([PropTypeShapes.elementOrArray, PropTypes.string, PropTypes.array])
};

export default InspectorGroupHeading;
